const hasDistributionList = (list) => {
  const scopeDictionary = {
    cstaff: {
      name: 'Command Staff',
      scope: 'cstaff',
    },
    chief: {
      name: 'Chief',
      scope: 'chief',
    },
    depadmin: {
      name: 'Department Administrator',
      scope: 'depadmin',
    },
    fto: {
      name: 'Field Training Officer',
      scope: 'fto',
    },
    ftoc: {
      name: 'Field Training Coordinator',
      scope: 'ftoc',
    },
    sup: {
      name: 'Supervisor',
      scope: 'sup',
    },
    oit: {
      name: 'Officer in Training',
      scope: 'oit',
    },
  };
  return {
    getDistributionList() {
      return list.map(scopeKey => scopeDictionary[scopeKey]);
    },
    getDistributionWithAdded(roleScope) {
      return [roleScope, ...list];
    },
    getDistributionWithRemoved(roleScope) {
      return list.filter(scopeKey => scopeKey !== roleScope);
    },
    getRolesNotInDistributionList() {
      const notInList = Object.keys(scopeDictionary).filter(scopeKey => !list.includes(scopeKey))
      return notInList.map(scopeKey => scopeDictionary[scopeKey]);
    },
  };
};

export default hasDistributionList;
